const root = document.querySelector('.bd-pso-store');

if (root) {
  if (new URL(window.location.href).searchParams.get('bd_mobile_qa') === '1') {
    root.classList.add('bd-force-mobile');
    document.body.classList.add('bd-mobile-qa');
  }

  const header = root.querySelector('.bd-header');
  const menuButton = root.querySelector('.bd-menu-toggle');

  menuButton?.addEventListener('click', () => {
    const next = header?.dataset.menuOpen !== 'true';
    if (header) header.dataset.menuOpen = String(next);
    menuButton.setAttribute('aria-expanded', String(next));
  });

  root.querySelectorAll('.bd-nav a').forEach((link) => {
    link.addEventListener('click', () => {
      if (header) header.dataset.menuOpen = 'false';
      menuButton?.setAttribute('aria-expanded', 'false');
    });
  });

  const mainImage = root.querySelector('[data-bd-main-image]');
  root.querySelectorAll('[data-bd-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = button.dataset.src || '';
      mainImage.alt = button.dataset.alt || 'Beauty Dose product image';
      root.querySelectorAll('[data-bd-thumb]').forEach((thumb) => thumb.setAttribute('aria-current', 'false'));
      button.setAttribute('aria-current', 'true');
    });
  });

  const variantInput = root.querySelector('[data-bd-variant-input]');
  const livePrice = root.querySelector('[data-bd-live-price]');
  root.querySelectorAll('[data-bd-bundle]').forEach((radio) => {
    radio.addEventListener('change', () => {
      if (!radio.checked) return;
      if (variantInput) variantInput.value = radio.value;
      if (livePrice) livePrice.textContent = radio.dataset.price || '';
      const image = radio.dataset.image;
      if (mainImage && image) {
        mainImage.src = image;
        mainImage.alt = radio.dataset.imageAlt || 'Beauty Dose bundle';
      }
    });
  });

  root.querySelectorAll('[data-bd-scroll-offer]').forEach((button) => {
    button.addEventListener('click', (event) => {
      const offer = root.querySelector('#bd-offer');
      if (!offer) return;
      event.preventDefault();
      offer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
}
